export default __webpack_public_path__ + "media/images/icons/icon-arrow-right-aafc6e4f63a39929dbe638df415e8edc.svg";